import { render, staticRenderFns } from "./custom-identifier-searcher.vue?vue&type=template&id=5336bafb&scoped=true&"
import script from "./custom-identifier-searcher.ts?vue&type=script&lang=ts&"
export * from "./custom-identifier-searcher.ts?vue&type=script&lang=ts&"
import style0 from "./custom-identifier-searcher.scss?vue&type=style&index=0&id=5336bafb&lang=scss&scoped=true&"
import style1 from "../../shared/styles/common-searcher.scss?vue&type=style&index=1&id=5336bafb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336bafb",
  null
  
)

export default component.exports